import { RewardFieldsBE } from "types/rewards";
import { array, boolean, number, object, string } from "yup";

const rewardSchema = object({
  active: boolean().required(),
  activity: object({
    allTime: boolean().required(),
    from: string(),
    to: string(),
  }).required(),
  categories: array().of(string()),
  costInPoints: number(),
  couponGenerator: object({
    characterSet: string(),
    length: number(),
    prefix: string(),
  }),
  couponValue: number(),
  dateValid: string().nullable(),
  daysInactive: number().nullable(),
  daysValid: number().nullable(),
  labels: array().of(
    object({
      key: string().required(),
      value: string().required(),
    }),
  ),
  levels: array().of(string()),
  price: number(),
  reward: string().oneOf([
    "material",
    "conversion_coupon",
    "static_coupon",
    "dynamic_coupon",
  ]),
  segments: array().of(string()),
  sourceWalletTypeCode: string(),
  target: string().oneOf(["level", "segment"]),
  translations: object().required(),
  unitsConversion: object({
    ratio: number(),
    rounding: string().oneOf(["default", "up", "down"]),
  }),
  usageLimit: object({
    general: number().nullable(),
    perUser: number().nullable(),
  }),
  visibility: object({
    allTime: boolean().required(),
    from: string(),
    to: string(),
  }).required(),
});

export const isRewardJsonValid = (reward: RewardFieldsBE) => {
  try {
    rewardSchema.validateSync(reward);

    return true;
  } catch {
    return false;
  }
};
